var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _sliceInstanceProperty2 = require("@babel/runtime-corejs3/core-js/instance/slice");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs3/core-js/instance/slice", "@babel/runtime-corejs3/core-js/json/stringify", "@babel/runtime-corejs3/core-js/date/now", "../constant", "../utils"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs3/core-js/instance/slice"), require("@babel/runtime-corejs3/core-js/json/stringify"), require("@babel/runtime-corejs3/core-js/date/now"), require("../constant"), require("../utils"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, _sliceInstanceProperty2(global), global.stringify, global.now, global.constant, global.utils);
    global.xhr = mod.exports;
  }
})(this, function (_exports, _slice, _stringify, _now, _constant, _utils) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = proxyXhr;
  _exports.upload = _exports.OriXhr = void 0;
  _slice = _interopRequireDefault(_slice);
  _stringify = _interopRequireDefault(_stringify);
  _now = _interopRequireDefault(_now);
  var OriXhr = window.XMLHttpRequest;
  _exports.OriXhr = OriXhr;
  var originOpen = OriXhr.prototype.open;
  var originSend = OriXhr.prototype.send;
  /**
   * 创建 proxyXhr
   */

  function proxyXhr() {
    var requestAction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _utils.noop;
    var responseAction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _utils.noop;
    var me = this;

    var _$get = _utils._.get(me, ['config', 'record'], {}),
        interfaceRecordConfig = _$get.api_report_config;

    var withBody = interfaceRecordConfig.withBody,
        withResp = interfaceRecordConfig.withResp,
        reportFilter = interfaceRecordConfig.reportFilter,
        sampleRate = interfaceRecordConfig.sampleRate,
        enable = interfaceRecordConfig.enable; // 重写open,初始化一个请求。
    // open接收的所有参数 [method, url, async, user, password]

    OriXhr.prototype.open = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var method = args[0],
          url = args[1];
      this.__reqCtx__ = {
        method: method,
        url: url || '',
        start: (0, _now.default)()
      };
      originOpen.apply(this, args);
    }; // 重写send,发送请求。
    // 接受一个可选的参数，其作为请求主体


    OriXhr.prototype.send = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var reqBody = args[0];
      var request = this;

      function callback() {
        if (request.__reqCtx__ && request.readyState === 4) {
          try {
            var end = (0, _now.default)();

            var manifest = (request.responseURL || request.__reqCtx__.url).split('?'); // 请求地址


            var reqUrl = manifest[0]; // get参数

            var param = manifest[1] || '';
            var pJSON = '';

            var method = request.__reqCtx__.method.toUpperCase();

            if (method !== 'GET' && reqBody) {
              pJSON = (0, _stringify.default)(reqBody);
            }

            var text = String(request.response);
            var hasObj = true;
            var result = {}; // 记录接口耗时

            var spend = end - request.__reqCtx__.start; // 用户过滤操作

            if (typeof reportFilter === 'function') {
              hasObj = !!(result = reportFilter.call(this, {
                url: reqUrl,
                status: request.status,
                response: text
              })); // me.debugLogger('XHR Filter\u6267\u884c\u7ed3\u679c\uff1a', result)
            }

            if (text.length > 1024) {
              text = (0, _utils.stringSlice)(text, 996, '[response content too large]');
            }

            var report = enable && (0, _utils.canReport)(sampleRate);

            if (!report) {
              responseAction({
                timestamp: end,
                spend: spend,
                method: method,
                url: reqUrl,
                status: request.status,
                message: request.statusText
              }); // me.debugLogger('XHR监测未打开或未命中抽样', enable, report)

              return;
            }

            if (hasObj && spend < 121e3) {
              // 业务code在200~299之间不记录报文内容
              var applyDataChange = result.bizCode || request.status;
              var needReport = (0, _utils.ifReportHttpError)(applyDataChange, reqUrl);
              me.interface(30001, {
                error_no: "API_XHR",
                url: reqUrl,
                method: method,
                http_code: request.status,
                biz_code: result.bizCode === undefined ? applyDataChange : result.bizCode,
                during_ms: spend
              }, {
                param: param,
                msg: result.msg || request.statusText || '',
                body: needReport && withBody ? pJSON : '',
                resp: needReport && withResp ? (0, _utils.stringSlice)(result.resp, 996, '[response content too large]') || text : ''
              });
            }

            responseAction({
              timestamp: end,
              spend: spend,
              method: method,
              url: reqUrl,
              status: request.status,
              message: request.statusText
            });
          } catch (msg) {}
        }
      }

      try {
        requestAction({
          type: 'api',
          timestamp: this.__reqCtx__.start,
          method: request.__reqCtx__.method.toUpperCase(),
          url: this.__reqCtx__.url.split('?')[0]
        });

        if ('onreadystatechange' in request && typeof request.onreadystatechange === 'function') {
          var handler = request.onreadystatechange;

          request.onreadystatechange = function () {
            var _arguments = (0, _slice.default)([]).call(arguments);

            callback.apply(this, _arguments);
            handler.apply(this, _arguments);
          };
        } else {
          request.onreadystatechange = callback;
        }
      } catch (e) {}

      originSend.apply(this, args);
    };
  }

  var upload = function upload(info) {
    var body = encodeURIComponent((0, _stringify.default)({
      list: [info]
    }));

    if (navigator.sendBeacon) {
      var headers = {
        type: 'application/x-www-form-urlencoded; charset=UTF-8',
        encoding: 'gzip'
      };
      var blob = new Blob(['d=' + body], headers);
      navigator.sendBeacon(_constant.TARGET, blob);
      return;
    }

    var xhr = new OriXhr();
    originOpen.call(xhr, 'POST', _constant.TARGET);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    xhr.setRequestHeader('Content-Encoding', 'gzip');
    originSend.call(xhr, 'd=' + body);
  };

  _exports.upload = upload;
});